import { h } from "preact";

import { classNames, countryCodeToFlagUrl } from "../helpers";
import i18n from "../i18n";

import Tooltip from "./Tooltip.jsx";
import RedactedInfo from "./RedactedInfo.jsx";

export default function CompanyAndCountry({
  smaller,
  company,
  user,
  previewMode,
  ...props
}) {
  return (
    <p
      class={classNames(
        "talent-short-view__pos-country mt-0",
        smaller && "talent-short-view--smaller",
        props.class
      )}
      data-testid="company-country"
    >
      <span class="talent-short-view__position">
        {previewMode ? <RedactedInfo inline small w80 /> : company.name}
      </span>
      ,{" "}
      <span class="talent-short-view__country">
        {i18n.t("component.company_and_country.de")}
        <span
          class="passpartout passpartout-24 ml-8"
          data-tooltip-id={`country-flag-${user.id}`}
        >
          <img src={countryCodeToFlagUrl("DE")} />
        </span>
      </span>
      <Tooltip
        className="nioomi-tooltip"
        id={`country-flag-${user.id}`}
        place="bottom"
      >
        {i18n.t("component.company_and_country.country_flag_tooltip")}
      </Tooltip>
    </p>
  );
}
